<template>
  <v-btn-form :title="title" @close="cancel()">
    <v-card-text>
      <v-flex>
          Действие планируется после заполнения даты и времени.
          <div>Внимание! Дата может заполняться автоматически.</div>
          <!-- {{value && value.command}} -->
      </v-flex>
      <v-layout row wrap>
      <v-flex xs5 sm6>
        <v-date-field
          placeholder="Сейчас"
          :value="scheduledDate"
          v-on:input="onChangeDate"
          :readonly="!isEdit"
        >
        </v-date-field>
      </v-flex>
      <v-flex xs2 sm2>
          <v-text-field
            placeholder="чч:мм"
            v-model="scheduledTime"
            mask = "##:##"
            :rules="[v => !v || /^(2[0-3]|[01]?[0-9])([0-5]?[0-9])$/.test(v) || 'чч:мм']"
            :readonly="!isEdit"
          >
          </v-text-field>
      </v-flex>
      <v-flex xs12 sm12>
        <v-textarea
          v-model = "value && value.command"
          rows="3"
          :readonly="!isEdit"
        >
      </v-textarea>
      </v-flex>
    </v-layout>
    </v-card-text>
    <template #actions>
      <v-btn v-show="!isEdit" @click="rollback()">Отменить выполнение</v-btn>
      <v-btn v-show="isEdit" @click="ok">ОК</v-btn>
    </template>
  </v-btn-form>
</template>

<script type="text/javascript">
  import server from '../../../api/server'
  import { mapGetters } from 'vuex'
  import vDateField from '../../common/DateField'
  import vBtnForm from '../../common/BtnForm'
  import moment from 'moment'

  // import depo from '.'

  export default {
    name: 'action-form',
    components: {vBtnForm, vDateField},
    data: () => ({
      cxt: null,
      scheduledDate: null,
      scheduledTime: null,
      command: null
    }),
    props: {
      fullscreen: {
        type: Boolean,
        default: false
      },
      radio: {
        type: Boolean,
        default: false
      },
      selected: {
        type: Array,
        default: function () {
          return []
        }
      },
      value: {
        type: Object,
        default: null
      },
      title: {
        type: String,
        default: 'Выберите документ'
      }
    },
    created () {
    },
    mounted () {
      this.fetchData()
    },
    watch: {
      value: function (newVal, oldVal) { // watch it
        this.fetchData()
      }
    },
    computed: {
      ...mapGetters({
        getIsMobile: 'getIsMobile',
        calcDialogScroll: 'calcDialogScroll'
      }),
      isEdit () {
        console.log('isEdit', this.value && this.value.logId)
        return !(this.value && this.value.logId)
      }
    },
    methods: {
      fetchData () {
        if (this.value) {
          if (this.value.scheduled) {
            let mom = moment(this.value.scheduled, moment.ISO_8601)
            this.scheduledDate = mom.format('YYYY-MM-DD')
            this.scheduledTime = mom.format('HHmm')
          }
          if (this.value.command) {
            this.command = this.value.command
          }
        }
      },
      ok () {
        let scheduled = null
        if (this.scheduledDate || this.scheduledTime) {
          let scheduledDate = this.scheduledDate || moment().format('YYYY-MM-DD')
          let scheduledTime = this.scheduledTime || moment().format('HHmm')
          scheduled = moment(`${scheduledDate} ${scheduledTime}`, 'YYYY-MM-DD HHmm', false).format('YYYY-MM-DD HH:mm')
        }
        this.$emit('input', {scheduled: scheduled, command: this.value && this.value.command || ''})
        this.cancel()
      },
      cancel () {
        this.$emit('close')
        this.itemId = null
      },
      onChangeDate (v) {
        console.log('onChangeDate', v)
        this.scheduledDate = v
      },
      rollback () {
        const cb = (data) => {
          this.$emit('input', {scheduled: null, command: this.command || ''})
          this.cancel()
        }
        const cbError = (e) => {
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при отмене действия '})
        }
        server.apiPost(
          '/api/me/action-rollbacks',
          {
            actionCode: 'MATTER_RUN',
            resourceId: this.value && this.value.logId || null
          },
          cb,
          cbError)
      }
    }
  }
</script>




// WEBPACK FOOTER //
// ActionForm.vue?6c30e870